import React from 'react';

interface Props {
  color?: string;
}

const Plate: React.FC<Props> = ({ color }) => {
  return (
    <svg width="200" height="80" viewBox="0 0 632 284">
      <path
        d="M583.9 280L62 283.9c-22.3 0-38-4.6-38-26.9L.3 40.3C.3 18.1-3.9 0 18.4 0l578.8 7c22.3 0 34 11.7 34 34l-6.9 198.7c0 10.7-4.3 20.9-11.8 28.5-7.6 7.6-17.9 11.8-28.6 11.8z"
        fill={color}
      />
      <path
        d="M65.6 167.5c13.1 0 23.8-10.7 23.8-23.8s-10.7-23.8-23.8-23.8-23.8 10.7-23.8 23.8 10.7 23.8 23.8 23.8zM588.4 167.5c13.1 0 23.8-10.7 23.8-23.8s-10.7-23.8-23.8-23.8c-13.2 0-23.8 10.7-23.8 23.8s10.6 23.8 23.8 23.8z"
        fill="#12bbf0"
      />
      <path
        d="M58.5 161.7c13.1 0 23.8-10.7 23.8-23.8 0-13.1-10.7-23.8-23.8-23.8s-23.8 10.7-23.8 23.8c0 13.1 10.6 23.8 23.8 23.8z"
        fill="#dcf6fe"
      />
      <path d="M69.4 127.9l-6.6-4.5-17 25.2 6.6 4.5 17-25.2z" fill="#12bbf0" />
      <path
        d="M580.3 161.1c13.1 0 23.8-10.7 23.8-23.8 0-13.1-10.7-23.8-23.8-23.8-13.2 0-23.8 10.7-23.8 23.8 0 13.2 10.6 23.8 23.8 23.8z"
        fill="#dcf6fe"
      />
      <path d="M592.1 127.9l-6.6-4.5-17 25.2 6.6 4.5 17-25.2z" fill="#12bbf0" />
    </svg>
  );
};

export default Plate;
